import React from "react";
import { motion } from "framer-motion";
import ibsLogo from "../images/ibslogo2.jpeg";
import CustomCursor from "../components/CustomCursor";
import TechToolbox from '../components/ToolBox';

const experiences = [
  {
    title: "Senior Software Engineer",
    company: "IBS Software (Vendor for Expedia Group)",
    duration: "July 2024 – May 2025",
    logo: ibsLogo,
    highlights: [
      "Automated Partner Onboarding Using Python – Designed Python-based automation scripts reducing onboarding time by 40%.",
      "Smart Redirection Engine – Deployed rule-based logic across 7 international Points of Sale, improving localization.",
      "Developed a rule parser for Lobot (Internal Tool) to dynamically identify POS relationships.",
      "Built dynamic travel widgets, booking components, and checkout features in Expedia’s platform.",
      "Worked closely with cross-functional teams to ship production-ready features under tight deadlines."
    ],
  },
  {
    title: "Software Engineer",
    company: "IBS Software",
    duration: "September 2022 – June 2024",
    logo: ibsLogo,
    highlights: [
      "Championed quality with rigorous unit testing, debugging, and code reviews.",
      "Collaborated with QA and DevOps teams during release cycles.",
      "Diagnosed and fixed critical bugs during high-traffic events and releases.",
      "Mentored peers and contributed to agile ceremonies to boost team velocity."
    ],
  },
];

const Experience = () => {
  return (
    <div className="relative bg-animated-gradient py-16 px-4 sm:px-6 text-white z-10">
      <CustomCursor />

      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl sm:text-4xl font-bold text-center mt-14 sm:mb-16 text-purple-400"
      >
        My Journey So Far
      </motion.h2>

      <p className="text-gray-300 text-center max-w-3xl mx-auto mb-10 text-base sm:text-lg px-2">
        With 2.5+ years of expertise in full-stack engineering, I specialize in building scalable web solutions. 
        At IBS Software, I have leveraged Python, Java, React.js, and modern web technologies to deliver impactful projects.
      </p>

      {/* Timeline */}
      <div className="relative max-w-4xl mx-auto">
        {/* Timeline line - hidden on small screens */}
        <div className="hidden sm:block absolute left-5 top-0 bottom-0 w-1 bg-purple-500/40 rounded-md"></div>

        <div className="space-y-12 sm:space-y-16 sm:pl-12">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2 }}
              viewport={{ once: true }}
              className="relative"
            >
              {/* Timeline marker (only for medium screens and above) */}
              <div className="hidden sm:block absolute left-[-5px] top-2 w-4 h-4 bg-purple-400 border-2 border-white rounded-full z-10"></div>

              <div className="bg-white/5 backdrop-blur-lg p-5 sm:p-6 rounded-lg border border-white/10 shadow-md hover:shadow-purple-400/20 transition duration-300">
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-3">
                  <img src={exp.logo} alt={exp.company} className="w-10 h-10 rounded" />
                  <div>
                    <h3 className="text-lg sm:text-xl font-semibold">{exp.title}</h3>
                    <p className="text-sm text-gray-400">{exp.company}</p>
                    <p className="text-xs text-purple-300">{exp.duration}</p>
                  </div>
                </div>
                <ul className="list-disc list-inside text-gray-300 text-sm sm:text-base mt-2 space-y-1">
                  {exp.highlights.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Tech Toolbox Section */}
        <div className="mt-20">
          <TechToolbox />
        </div>
      </div>
    </div>
  );
};

export default Experience;
